module.exports = __webpack_public_path__ + "static/media/thumb.952e04bd.jpg";